import * as React from "react";

export const ChevronD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Chevron">
      <path
        id="primary"
        d="M2 5L7.83784 11L14 5"
        stroke="#0F0F14"
        strokeLinecap="square"
      />
    </g>
  </svg>
);

export const Download = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Download">
      <path
        id="primary"
        d="M9.78398 14.2333V2.5M9.78398 14.2333L5.89209 9.96667M9.78398 14.2333L13.8921 9.96667M2.5 17.5H17.5"
        stroke="#FAFAFF"
        strokeLinecap="square"
      />
    </g>
  </svg>
);
